import React from "react";
import { Container, Row, Col } from "reactstrap";

import DefaultFooter from "../../Components/Footers/DefaultFooter";
import DarkNavbar from "../../Components/Navbars/DarkNavbar";

const Help = (props) => {
  return (
    <>
      <DarkNavbar />
      <div className="wrapper">
        <div className="section">
          <div className="projects-5">
            <Container>
              <Row>
                <Col className="ml-auto mr-auto text-center" md="8">
                  <h2 className="title">How to navigate through this site</h2>
                  <h4 className="description">
                    This will show how to navigate, use and upload results for
                    an event
                  </h4>
                  <div className="section-space"></div>
                </Col>
              </Row>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/1.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Landing Page</h4>
                      <p className="description">
                        Here you can click Login to either create your profile
                        or log onto an existing profile
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Login Page</h4>
                      <p className="description">
                        If you have an account, you can enter your username and
                        password and click the Get Started button. <br />
                        If you do not have an account, click the Create Account
                        button.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/2.png").default} />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/3.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Registration Page</h4>
                      <p className="description">
                        Here you will be able to create an account, enter the
                        necessary information and click the Get Started button.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Main Page</h4>
                      <p className="description">
                        After successfully being authenticated, you you will be
                        presented with this page.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/4.png").default} />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/5.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Profile Page</h4>
                      <p className="description">
                        Here you will see a list of open events and results that
                        you have submitted.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Event Page</h4>
                      <p className="description">
                        To enter for any of these events you can click the event
                        you wish to submit your results for.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/6.png").default} />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/7.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Event Capture</h4>
                      <p className="description">
                        Once you have clicked on an event to submit results, you
                        will be presented with this page, to either link your
                        profile to your Strava account or to submit your results
                        manually.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Manual Event Capture</h4>
                      <p className="description">
                        Enter the necessary information and click Submit to save
                        your run.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/8.png").default} />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/9.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Strava Import</h4>
                      <p className="description">
                        When clicking on the Strava method, you will be
                        presented with this screen. It is required that you
                        authorize All My Sports SA to access your exercise data
                        on Strava.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Successful Strava Link</h4>
                      <p className="description">
                        Once you allow All My Sports SA access to Strava, you
                        will get this notification.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/10.png").default} />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/11.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">
                        Profle Page (Strava Linked)
                      </h4>
                      <p className="description">
                        We now have your run data from Strava.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">
                        Select Event (Strava Linked)
                      </h4>
                      <p className="description">
                        Click on event to capture your results.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/12.png").default} />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/14.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Strava Method Import</h4>
                      <p className="description">
                        When selecting Strava as an import method, we will list
                        all the exercise data that fit the criteria for the
                        event you're entering.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Run Selection (Strava)</h4>
                      <p className="description">
                        Click the Use Run button, and you'll get this
                        confirmation message. Select Yes if you wish to proceed
                        to use the run for the event.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/15.png").default} />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/16.png").default} />
                </Col>
                <Col className="mr-auto" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-danger">
                      <i className="now-ui-icons ui-2_chat-round"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Run Saved (Strava)</h4>
                      <p className="description">
                        Your run will then be saved to your profile.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col className="ml-auto mt-5" md="5">
                  <div className="info info-horizontal">
                    <div className="icon icon-warning">
                      <i className="now-ui-icons business_bulb-63"></i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Profile (Captured events)</h4>
                      <p className="description">
                        Here you can find the list of events you have entered.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="ml-auto">
                  <img src={require("../../assets/img/help/13.png").default} />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
};

export default Help;
